import { useState } from 'react';
import type { ModalProps } from 'core/components/ui';
import { Button, TeamOutlined } from 'core/components/ui';
import { t } from 'i18next';
import { UsersModal } from 'core/containers';

export function UsersRoles() {
  const [open, setOpen] = useState(false);
  const modalProps: ModalProps = {
    title: t('Users.ModalRolesTitle'),
    open,
    onCancel: () => setOpen(false),
  };

  return (
    <>
      <Button icon={<TeamOutlined />} onClick={() => setOpen(true)} type="link" />
      <UsersModal modalProps={modalProps} />
    </>
  );
}
